global.printThis = require('../../../../node_modules/print-this/printThis.js');